import { Component, h, Prop } from '@stencil/core';
import { NewsClient } from '../../../api/APIClient';

@Component({
  tag: 'c7-news-show-all',
  styleUrl: 'show-all-link.styles.scss',
  shadow: false
})
export class ShowAllLink {

  @Prop() page!: number;

  @Prop() categories!: number[];

  @Prop({mutable: true}) slug: string = "#";

  @Prop() title: string = 'Leitet zur News-Übersicht weiter';

  private client: NewsClient = new NewsClient();

  async componentDidLoad(){
    if(this.slug === '#') {
      const {slugs} = await this.client.getSettings(this.page, this.categories);
      this.slug = slugs[0]?.slug;
    }
  }

  render(){

    const cssClassNames = {
      'c7-news-show-all': true,
    }

    const {slug, title} = this;

    return (
      <a class={cssClassNames} href={slug} title={title}>
        <slot />
      </a>
    )
  }

}

